import $ from 'jquery'
import {register} from '@shopify/theme-sections'
import {Tabs} from '../modules/tabs'
import 'slick-carousel'
import '../../styles/sections/index-featured-products.scss'

export default register(`index-featured-products`, {
  onLoad() {
    const containerID = this.container.id
    if (!containerID) {
      return
    }
    $(`#${containerID}`).each(function(index) {
      const sliders = $(this).find(`.slick-slider:not(.slick-initialized)`)
      if (sliders) {
        sliders.slick()
      }
    })

    Tabs(containerID)
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

